import { render, staticRenderFns } from "./iField.vue?vue&type=template&id=372092b0&scoped=true&"
import script from "./iField.vue?vue&type=script&lang=js&"
export * from "./iField.vue?vue&type=script&lang=js&"
import style0 from "./iField.vue?vue&type=style&index=0&id=372092b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372092b0",
  null
  
)

export default component.exports